import { RoomMember } from '../store/room'
import '../css/App.css'

interface Props {
  members:     RoomMember[]
  maxSeats:    number
  myUserCode:  number
  tabActive?:  boolean
  // SEQ=10072 STEP B — 옵저버 시스템
  roomStatus?: string                              // WAITING / STARTED / POST_GAME
  onTakeSeat?:  () => void                         // 옵저버 → 플레이석
  onLeaveSeat?: () => void                         // 플레이어 → 옵저버석
}

export default function MemberPanel({
  members, maxSeats, myUserCode, tabActive,
  roomStatus, onTakeSeat, onLeaveSeat,
}: Props) {
  const players   = members.filter(m => m.seatType === 'PLAYER')
  const observers = members.filter(m => m.seatType === 'OBSERVER')

  // 플레이석 슬롯 (0 ~ maxSeats-1)
  const playerSlots = Array.from({ length: maxSeats }, (_, i) =>
    players.find(m => m.seatIndex === i) ?? null
  )

  const me = members.find(m => m.userCode === myUserCode)
  const myType = me?.seatType ?? 'PLAYER'
  const isMeHost = !!me?.isHost
  // 비진행(WAITING/POST_GAME)에서만 좌석 이동 가능
  const canMoveSeat = roomStatus === 'WAITING' || roomStatus === 'POST_GAME'
  const playerFull  = players.length >= maxSeats

  return (
    <div className={`member-panel${tabActive ? ' tab-active' : ''}`}>
      <h4 className="panel-title">
        참가자 <span className="seat-count">{players.length}/{maxSeats}</span>
      </h4>
      <ul className="seat-list">
        {playerSlots.map((member, i) => (
          <li
            key={`p${i}`}
            className={[
              'seat-slot',
              member ? 'seat-occupied' : 'seat-empty',
              member?.userCode === myUserCode ? 'seat-mine' : '',
            ].filter(Boolean).join(' ')}
          >
            {member ? (
              <span className="seat-name">
                {member.isHost && <span className="host-crown">&#128081;</span>}
                {member.nickname}
                {member.userCode === myUserCode && <span className="seat-you"> (나)</span>}
              </span>
            ) : (
              <span className="seat-empty-label">&mdash; 비어있음 &mdash;</span>
            )}
          </li>
        ))}
      </ul>

      {/* SEQ=10072 STEP B — 관전석 섹션 */}
      <h4 className="panel-title observer-title">
        관전 <span className="seat-count">{observers.length}/{maxSeats}</span>
      </h4>
      {observers.length === 0 ? (
        <div className="observer-empty">관전자 없음</div>
      ) : (
        <ul className="seat-list observer-list">
          {observers.map(m => (
            <li
              key={`o${m.userCode}`}
              className={[
                'seat-slot', 'seat-occupied', 'seat-observer',
                m.userCode === myUserCode ? 'seat-mine' : '',
              ].filter(Boolean).join(' ')}
            >
              <span className="seat-name">
                <span className="observer-eye">&#128065;</span>
                {m.nickname}
                {m.userCode === myUserCode && <span className="seat-you"> (나)</span>}
              </span>
            </li>
          ))}
        </ul>
      )}

      {/* 좌석 이동 버튼 — 비진행 중에만 노출 */}
      {canMoveSeat && me && (
        <div className="seat-move-actions">
          {myType === 'OBSERVER' && onTakeSeat && (
            <button
              type="button"
              className="btn-take-seat"
              onClick={onTakeSeat}
              disabled={playerFull}
              title={playerFull ? '플레이석이 가득 찼습니다' : '플레이석으로 이동'}
            >
              {playerFull ? '플레이석 가득 참' : '플레이석으로 이동'}
            </button>
          )}
          {myType === 'PLAYER' && onLeaveSeat && (
            <button
              type="button"
              className="btn-leave-seat"
              onClick={onLeaveSeat}
              disabled={isMeHost}
              title={isMeHost ? '방장은 먼저 방장을 양도해야 합니다' : '관전석으로 이동'}
            >
              {isMeHost ? '방장은 이동 불가' : '관전석으로 이동'}
            </button>
          )}
        </div>
      )}
    </div>
  )
}
